import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    showBalance: false,
};
const showBalanceSlice = createSlice({
    name: 'showBalance',
    initialState,
    reducers: {
        toggleShowBalance: state => {
            state.showBalance = !state.showBalance;
        },
        setShowBalance: (state, action) => {
            state.showBalance = action.payload;
        },
        hideBalance: state => {
            state.showBalance = false;
        },
        showBalance: state => {
            state.showBalance = true;
        },
    },
});
export const { toggleShowBalance, setShowBalance, hideBalance, showBalance } = showBalanceSlice.actions;
export default showBalanceSlice.reducer;
